<template>
  <div>
      <time-tip :msgObj="msgObj" v-if="msgObj.showSendTime"/>

      <component :is="comps[msgObj.msgType]" :msgObj="msgObj" :isMe="isMe"/>
  </div>
</template>

<script>
import templates from './templates'

export default {
  name: "message-item",
  components: {
    ...templates
  },
  data() {
    return {
      comps: {
        "-3": "tpl-loading",
         "-2": "text-tip",
         "0": "tpl-to-customer",
         "1": "tpl-text",
         "2": "tpl-image",
         "3": "tpl-qs-list",
         "4": "tpl-file"
      }
    }
  },
  props: {
    msgObj: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMe() {
      return this.msgObj.userType == 1;
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/MessageItem.vue